import setClientState from './setClientState';

export default {
  setClientState,
};
